import { P, Text } from '@mxenabled/mxui'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { Drawer, useGlobalCopyStore } from '../../../common'
import { HelpCopy } from '../../../core'
import { RequestSupportHeader } from './RequestSupportHeader'
import { buildDynamicCopy } from '../../../core/utils/Localization'

interface RequestSupportInstitutionProps {
  copy: HelpCopy
  institution: string
  isOpen: boolean
  onClose: () => void
  popularTopicsDrawerOnClose: () => void
  title: string
}

export const RequestSupportInstitution: React.FC<RequestSupportInstitutionProps> = ({
  copy,
  institution,
  isOpen,
  onClose,
  popularTopicsDrawerOnClose,
  title,
}) => {
  const { common: commonCopy } = useGlobalCopyStore()
  return (
    <Drawer isOpen={isOpen} onClose={onClose} title={copy.request_support}>
      <RequestSupportHeader
        hasIcon={false}
        institution={institution}
        reverse={true}
        subtitle={copy.request_support_institution_short_content}
        title={title}
      />
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: '0px 2px 8px rgba(106, 115, 129, 0.12)',
          m: 24,
          p: 24,
        }}
      >
        <Text
          color="secondary"
          sx={{
            fontWeight: 600,
          }}
          variant="body1"
        >
          {buildDynamicCopy(copy.request_support_institution_message_title, institution) as string}
        </Text>
        <P
          color="secondary"
          sx={{
            fontWeight: 400,
            mt: 2,
          }}
          variant="subtitle2"
        >
          {buildDynamicCopy(copy.request_support_institution_message, institution) as string}
        </P>
      </Box>

      <Stack direction="column" spacing={8} sx={{ mx: 24 }}>
        <Button onClick={popularTopicsDrawerOnClose} variant="contained">
          {commonCopy.done_button}
        </Button>
        <Button onClick={onClose} variant="text">
          {copy.request_support_institution_back}
        </Button>
      </Stack>
    </Drawer>
  )
}
